<app-ep-generic-dialog class="teaser-main-dialog">
  <ng-container dialog-content> <app-teaser-details (closeTeaserPage)="close()"></app-teaser-details> </ng-container>
</app-ep-generic-dialog>
